import { cn } from "../lib/cn";
import { SamklangLoader } from "./samklang-loader";

export type SpinnerProps = {
  className?: string;
  size?: "sm" | "md" | "lg";
  label?: string;
};

const sizeClass = {
  sm: "h-4 w-4",
  md: "h-5 w-5",
  lg: "h-7 w-7",
} as const;

export function Spinner({
  className,
  size = "md",
  label = "Laddar",
}: SpinnerProps) {
  return (
    <SamklangLoader
      variant="spin"
      size="md"
      label={label}
      className={cn(
        "inline-block",
        sizeClass[size],
        className
      )}
    />
  );
}
